import { Card, Input, Slider } from "antd"

export default function ConfidenceThreshold({ threshold, onThresholdChange }) {
  return (
    <Card
      bordered={false}
      headStyle={{ borderBottom: "1px solid #e5e7eb", padding: "16px 16px 12px 16px" }}
      bodyStyle={{ padding: "16px" }}
      title={<div className="text-sm">CONFIDENCE THRESHOLD</div>}
      className="w-full"
    >
      <div className="flex gap-2 justify-between">
          <Input
            type="number"
            step="0.01"
            min="0"
            max="1"
            value={threshold.toFixed(2)}
            onChange={(e) => onThresholdChange(Number.parseFloat(e.target.value))}
            className="w-[10rem] text-center text-sm"
          />
          <div className="flex flex-1 items-center gap-2">
          <Slider value={threshold} onChange={onThresholdChange} max={1} step={0.01} className="flex-1" />
          <p className="text-xs text-right">- Signals below this are suppressed</p>
        </div>
      </div>
    </Card>
  )
}
